// Help Center API Configuration
// NOTE: getTicketPortalApiUrl removed in Phase 5 — ticket portal now uses the
// JWT main API at /v6/ticket-portal. getHelpCenterBaseUrl remains for axiosJira
// which is still used by src/feature-requests for /app/jira/* calls.

const HELP_CENTER_BASE_URL = "https://helpcenter-dev.api.aeronet.nz";
export const HELPCENTER_API_KEY = "bingbongwallawalllbingbang";

const normalizeBaseUrl = (baseUrl: string): string => baseUrl.replace(/\/+$/, "");

export const getHelpCenterBaseUrl = (): string => normalizeBaseUrl(HELP_CENTER_BASE_URL);
